import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import QUERY, {
	type IssueHierarchyViewQuery,
} from './__generated__/IssueHierarchyViewQuery.graphql';

export const issueHierarchyPageResource = createRelayResource<IssueHierarchyViewQuery>({
	type: 'RESOURCE1',
	getQuery: (_, { tenantContext }) => ({
		parameters: QUERY,
		variables: {
			cloudId: tenantContext.cloudId,
		},
	}),
});
